import { HTMLProps } from "react";
import { cn } from "@/utils/helpers";
import styles from "../Panel.module.css";

export interface PanelBackdropProps extends HTMLProps<HTMLElement> {
	show?: boolean;
}

export default function PanelBackdrop({
	show = true,
	onClick,
	className
} : PanelBackdropProps) {
	return (
		<div
			onClick={onClick}
			className={cn(
				className,
				styles.PanelBackdrop,
				show ? styles.PanelBackdrop_show : null,
			)}
		/>
	)
}